import { render, staticRenderFns } from "./TxnComments.vue?vue&type=template&id=572061a6"
import script from "./TxnComments.vue?vue&type=script&lang=js"
export * from "./TxnComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports